var _circle, _circle2, _circle3, _circle4, _circle5, _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgShareEmoji(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 45,
    viewBox: "0 0 48 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 6.27473,
    cy: 6.27473,
    r: 5.27473,
    transform: "matrix(1 0 0 -1 17.6865 42.7856)",
    stroke: "white",
    strokeWidth: 2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 6.27473,
    cy: 6.27473,
    r: 5.27473,
    transform: "matrix(1 0 0 -1 2 28.6674)",
    stroke: "white",
    strokeWidth: 2
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 6.27473,
    cy: 6.27473,
    r: 5.27473,
    transform: "matrix(-1 8.74228e-08 8.74228e-08 1 45.9224 1.99994)",
    stroke: "white",
    strokeWidth: 2
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 6.27473,
    cy: 6.27473,
    r: 5.27473,
    transform: "matrix(1 0 0 -1 17.6865 28.6674)",
    stroke: "white",
    strokeWidth: 2
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 6.27473,
    cy: 6.27473,
    r: 5.27473,
    transform: "matrix(-1 8.74228e-08 8.74228e-08 1 30.2358 1.99994)",
    stroke: "white",
    strokeWidth: 2
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    y1: -1,
    x2: 17.7476,
    y2: -1,
    transform: "matrix(0.707107 -0.707107 -0.707107 -0.707107 2 42.7856)",
    stroke: "white",
    strokeWidth: 2
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    y1: -1,
    x2: 17.7476,
    y2: -1,
    transform: "matrix(0.707107 0.707107 0.707107 -0.707107 2 30.2361)",
    stroke: "white",
    strokeWidth: 2
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    y1: -1,
    x2: 17.7476,
    y2: -1,
    transform: "matrix(0.707107 -0.707107 -0.707107 -0.707107 33.374 28.6674)",
    stroke: "white",
    strokeWidth: 2
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    y1: -1,
    x2: 17.7476,
    y2: -1,
    transform: "matrix(0.707107 0.707107 0.707107 -0.707107 33.374 16.1179)",
    stroke: "white",
    strokeWidth: 2
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    y1: -1,
    x2: 17.7476,
    y2: -1,
    transform: "matrix(-0.707107 0.707107 0.707107 0.707107 14.5498 1.99994)",
    stroke: "white",
    strokeWidth: 2
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    y1: -1,
    x2: 17.7476,
    y2: -1,
    transform: "matrix(-0.707107 -0.707107 -0.707107 0.707107 14.5498 14.5494)",
    stroke: "white",
    strokeWidth: 2
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    y1: -1,
    x2: 17.7476,
    y2: -1,
    transform: "matrix(0.707107 -0.707107 -0.707107 -0.707107 33.374 42.7856)",
    stroke: "white",
    strokeWidth: 2
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    y1: -1,
    x2: 17.7476,
    y2: -1,
    transform: "matrix(0.707107 0.707107 0.707107 -0.707107 33.374 30.2361)",
    stroke: "white",
    strokeWidth: 2
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareEmoji);
export default __webpack_public_path__ + "static/media/share-emoji.344dd3cc151c3a989ff8cbb4541fc731.svg";
export { ForwardRef as ReactComponent };